import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

import { VendorDetailsResponseType } from '../@types/configBank'

export const fetchConfigBankDataApi = (url: string, params?: { [key: string]: string }) =>
  axiosInstanceApiGateway.Get<VendorDetailsResponseType, true>({
    url,
    params,
  })

export const downloadConfigBankTableApi = (url: string, invalid_only: boolean) =>
  axiosInstanceApiGateway.Get<{ data: { queuing: boolean; file_url: string } }, true>({
    url,
    params: {
      invalid_only,
    },
  })

export const fetchConfigBankAlertApi = (url: string) =>
  axiosInstanceApiGateway.Get<{ data: { is_data_invalid: boolean } }, true>({
    url,
  })

export const getDocFileUrlAPI = (fileUrl: string, type: string) =>
  axiosInstanceApiGateway.Get<Blob, true>({
    url: '/internal/:version/scms-forecast/download',
    version: 'v1',
    params: { fileUrl },
    config: {
      baseURL: process.env.REACT_APP_BASE_URL_API_FILE_SERVICE,
      responseType: 'blob',
      transformResponse: (data) => new Blob([data], { type }),
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'X-Service-Name': 'astro-app-web-admin',
      },
    },
  })

export const getOrderDaysFFAPI = () =>
  axiosInstanceApiGateway.Get<{ data: { FF_ENABLE_SCMS_ORDER_DAYS: string } }, true>({
    url: '/commercial/internal/:version/feature-flags?flags=FF_ENABLE_SCMS_ORDER_DAYS',
    version: 'v1',
  })
